__webpack_require__.p = "/Web-Personal-Portfolio/";